import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import { useAuth } from "./lib/useAuth";
import Certs from "./pages/Certs";
import DailyReview from "./pages/DailyReview";
import Dashboard from "./pages/Dashboard";
import Home from "./pages/Home";
import Authoring from "./pages/Authoring";
import Login from "./pages/Login";
import MockExam from "./pages/MockExam";
import Practice from "./pages/Practice";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-ink-700">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Home />} />
        <Route path="certs" element={<Certs />} />
        <Route path="practice/:certId" element={<Practice />} />
        <Route path="mock-exam/:certId" element={<MockExam />} />
        <Route path="review" element={<DailyReview />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="authoring" element={<Authoring />} />
      </Route>
    </Routes>
  );
}
